module.exports = __webpack_public_path__ + "img/IGNIS GLS+.9b81a24b.png";